<template>
  <div class="salesgear-crm-component">
    <div
      class="salesgear-wrapper"
      v-if="!loading"
      @click.stop="checkSalesgearConnected"
    >
      <div
        v-if="!showAeExportDropdown && showDropDown"
        :class="[
          'dropdown-wrapper animatedDropDown animatedFast ',
          getBannerClass()
        ]"
      >
        <span :class="['sharp__pointer ', getBannerClass()]"></span>
        <div
          class="ae-proceed-section"
          v-if="!isTryNowClicked && showSalesgearProceed"
        >
          <p>
            Finish setting up your Salesgear
            <br />account to continue.
          </p>
          <V-Button
            :className="'btn-blue'"
            :text="'Proceed'"
            :callback="redirectToSalesgearSeq"
          />
        </div>
        <div v-else>
          <Main-Menu
            v-if="showManiMenu"
            v-on:setMainMenu="setMainMenu"
            v-on:exportContact="exportContact"
          />
          <Sequence-Section
            v-else
            v-on:setMainMenu="setMainMenu"
            v-on:addContactToSequence="scheduleSequence"
            :contactData="contact"
          />
        </div>
      </div>
      <img
        class="salesgear-logo"
        v-if="showSalesgearIcon"
        src="@/assets/images/salesgearLogo.png"
      />
      <i
        v-if="showSequenceIcon"
        class="fa fa-paper-plane-o galleryImg"
        aria-hidden="true"
      ></i>
      <V-Button
        v-if="showExportBannerBtn"
        :callback="tryNowSeqContactExport"
        :className="'try-now-export-btn'"
        :text="'Try Now'"
        :loading="false"
      />
    </div>
    <spinner v-else />
    <div
      class="overlay"
      v-if="!showAeExportDropdown && showDropDown"
      @click="hideDropDown"
    ></div>
    <Salesgear-Upgrade-Popup v-if="isContactLimit" />
    <Salesgear-Connect-Email v-if="showConnectEmail" />
    <Salesgear-Duplicate-Contact-Popup
      v-if="isDupContact"
      v-on:confirmExport="checkAndUpdateExport"
    />
    <Salesgear-Popup v-if="showPopup" v-on:clickedOutside="showPopup = false" />
    <Add-Token-Variable-Popup
      v-if="showTokenInputPopup"
      :tokenList="tokenList"
      :seqId="seqId"
      v-on:scheduleSequenceWithToken="scheduleSequenceWithToken"
      v-on:closeTokenPopup="showTokenInputPopup = false"
    />
  </div>
</template>

<script>
import { postFromCustomUrl, getFromCustomUrl } from '@/assets/util/rest'
import {
  SALESGEAR_URL,
  AE_PRODUCT_BASE_URL
} from '@/assets/util/constants/constants'
import {
  windowUrlRedirect,
  constructSalesgearUrl
} from '@/assets/util/commonUtil'
import shareFunction from '@/assets/util/functions'
import { MxEvent, HttpUrl } from '@/assets/util/constants/analytics'
import Spinner from '@/components/Spinner'
import MainMenuVue from './MainMenu'
import SequenceSectionVue from './SequenceSection'
import SalesgearUpgradePopupVue from '@/components/crmExport/salesgear/SalesgearUpgradePopup'
import SalesgearConnectEmailPopupVue from '@/components/crmExport/salesgear/SalesgearConnectEmailPopup'
import SalesgearDuplicateContactPopupVue from '@/components/crmExport/salesgear/SalesgearDuplicateContactPopup'
import ButtonVue from '@/components/Button'
import AddTokenVariablePopup from '@/components/crmExport/salesgear/AddTokenVariablePopup'
import SalesgearApiConnectPopup from '@/components/crmExport/salesgear/SalesgearApiConnectPopup.vue'

export default {
  name: 'AddToSalesgear',
  props: [
    'contactData',
    'trigger',
    'showUpgradePopup',
    'pageType',
    'showSalesgearIcon',
    'showSequenceIcon',
    'showExportBannerBtn',
    'companyData',
    'openTokenVariable',
    'showActivationPopup'
  ],
  data: function() {
    return {
      loading: false,
      showDropDown: false,
      showManiMenu: true,
      exportAs: 'contact',
      showSalesgearProceed: false,
      isTryNowClicked: false,
      showAeExportDropdown: false,
      isUserHasTeam: false,
      showTokenInputPopup: false,
      tokenList: [],
      seqObj: false,
      seqId: '',
      showPopup: false
    }
  },
  components: {
    Spinner,
    'Main-Menu': MainMenuVue,
    'Sequence-Section': SequenceSectionVue,
    'Salesgear-Upgrade-Popup': SalesgearUpgradePopupVue,
    'Salesgear-Connect-Email': SalesgearConnectEmailPopupVue,
    'Salesgear-Duplicate-Contact-Popup': SalesgearDuplicateContactPopupVue,
    'V-Button': ButtonVue,
    'Add-Token-Variable-Popup': AddTokenVariablePopup,
    'Salesgear-Popup': SalesgearApiConnectPopup
  },
  computed: {
    contact() {
      let contactData = this.contactData || {}
      let companyData = this.companyData || {}
      let data = {}
      if (contactData && Object.keys(contactData).length) {
        const {
          firstName = '',
          lastName = '',
          email = '',
          title = '',
          phone = '',
          linkedinId = ''
        } = contactData
        if (firstName) {
          data.firstName = firstName
        }
        if (lastName) {
          data.lastName = lastName
        }
        if (email) {
          data.email = email
        }
        if (title) {
          data.jobTitle = title
        }
        if (linkedinId) {
          data.linkedinId = linkedinId
        }
        const phoneList = this.getPhoneNumber(phone)
        if (phoneList && phoneList.length) {
          data.phone = phoneList
        }
      }

      if (companyData && Object.keys(companyData).length) {
        const {
          industry = '',
          street = '',
          city = '',
          state = '',
          country = '',
          zip = '',
          name = '',
          primaryDomain = ''
        } = companyData
        if (industry) {
          data.industry = industry
        }
        if (street) {
          data.street = street
        }
        if (city) {
          data.city = city
        }
        if (state) {
          data.state = state
        }
        if (country) {
          data.country = country
        }
        if (zip) {
          data.zipCode = zip
        }
        if (name) {
          data.company = name
        }
        if (primaryDomain) {
          data.website = primaryDomain
        }
      }
      return data
    },
    isContactLimit() {
      return this.$store.state.salesgear.isContactLimit
    },
    showConnectEmail() {
      return this.$store.state.salesgear.showConnectEmail
    },
    isDupContact() {
      return this.$store.state.salesgear.isDupContact
    },
    isAccountVerified: function() {
      return this.$store.state.header.emailStatus == 0
    }
  },
  methods: {
    hideDropDown() {
      this.showDropDown = false
      this.showAeExportDropdown = false
      this.isTryNowClicked = false
    },
    setMainMenu(response) {
      shareFunction.track(
        MxEvent.aeAddSequenceClicked,
        { pageType: this.pageType },
        this.$store.state
      )
      this.showManiMenu = response
    },
    async checkSalesgearConnected() {
      if (!this.isAccountVerified) {
        this.showActivationPopup()
      } else {
        let response = await getFromCustomUrl(
          constructSalesgearUrl(HttpUrl.validateApiKey)
        )
        let { isSalesgearApiConnected } = await response.json()
        if (isSalesgearApiConnected) {
          this.getCustomFields()
          this.showDropDownElement()
        } else {
          this.showPopup = true
        }
      }
    },
    showDropDownElement() {
      if (localStorage.getItem('SalesgearIntroBanner')) {
        shareFunction.track(
          MxEvent.aeIconClicked,
          { pageType: this.pageType },
          this.$store.state
        )
        this.showDropDown = !this.showDropDown
        this.setMainMenu(this.showDropDown)
      } else {
        this.showSalesgearProceed = true
        this.showDropDown = true
      }
    },
    checkAndUpdateExport() {
      this.exportAs === 'contact'
        ? this.updateContact()
        : this.scheduleSequence(null)
    },
    async updateContact() {
      this.loading = true
      const exportUrl = constructSalesgearUrl(HttpUrl.exUpdateSingleContactToAe)
      const payload = {
        contacts: [this.contact]
      }
      let response = await postFromCustomUrl(exportUrl, payload)
      if (response.status == 200 || response.status == 409) {
        this.loading = false
        response.json().then(res => {
          // eslint-disable-next-line no-unused-vars
          const { responseCode, contact = '', contactOwner = '' } = res
          if (responseCode) {
            this.checkContactStatus(responseCode, contactOwner, true)
          }
        })
      } else {
        this.loading = false
        this.showFailedToExport()
      }
    },
    scheduleSequence(obj) {
      this.hideDropDown()
      if (shareFunction.sequenceHasStage(obj)) {
        if (obj) {
          this.selectedSequenceObj = obj
        }
        this.seqId = this.selectedSequenceObj.id
        this.exportAs = 'sequence'
        const url = constructSalesgearUrl('/seq/addContact.htm')
        const data = {
          contact: this.contact,
          sequenceId: this.selectedSequenceObj.id,
          openTrack: true,
          linkTrack: true,
          force: true
        }
        let mergedTokenList = shareFunction.checkSubjectStageHasToken(obj)
        if (
          mergedTokenList &&
          mergedTokenList.length &&
          this.contact &&
          Object.keys(this.contact).length
        ) {
          this.tokenList = shareFunction.getContactEmptyToken(
            mergedTokenList,
            this.contact
          )
          if (this.tokenList.length) {
            this.showTokenInputPopup = true
          } else {
            this.scheduleSequenceForContact(url, data)
          }
        } else {
          this.scheduleSequenceForContact(url, data)
        }
      } else {
        shareFunction.showNotificationMsg(
          'Add stages before adding contacts to a sequence',
          null
        )
      }
    },
    scheduleSequenceWithToken(obj) {
      const { seqId, tokenData } = obj
      this.exportAs = 'sequence'
      const url = constructSalesgearUrl('/seq/addContact.htm')
      const data = {
        contact: { ...this.contact, ...tokenData },
        sequenceId: seqId,
        openTrack: true,
        linkTrack: true,
        force: true
      }
      this.showTokenInputPopup = false
      this.scheduleSequenceForContact(url, data)
    },
    scheduleSequenceForContact(url, data) {
      this.loading = true
      postFromCustomUrl(url, data)
        .then(response => {
          this.loading = false
          if (response.status == 200) {
            response.json().then(res => {
              if (res && res.responseCode === 200) {
                const msg = `Successfully added to the Sequence`
                shareFunction.showNotificationMsg(msg)
                shareFunction.track(
                  MxEvent.aeAddSeq,
                  { pageType: this.pageType },
                  this.$store.state
                )
                shareFunction.track(
                  MxEvent.aeSequenceStarted,
                  { pageType: 'Prospector' },
                  this.$store.state
                )
              } else {
                this.processSequenceError(res)
              }
            })
          } else {
            const msg = `Error while adding to the Sequence. Please contact support at support@adapt.io`
            shareFunction.showNotificationMsg(msg)
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    processSequenceError(res) {
      switch (res.responseCode) {
        case 104:
          shareFunction.showNotificationMsg(
            'Add stages before adding contacts to a sequence',
            null
          )
          break
        case 105:
          shareFunction.track(
            MxEvent.aeAddEmailAccountShown,
            { pageType: this.pageType },
            this.$store.state
          )
          this.$store.state.salesgear.showConnectEmail = true
          break
        case 103:
          shareFunction.showNotificationMsg(
            'This contact is opted out. You cannot add this contact to any Sequence'
          )
          break
        case 102:
          shareFunction.showNotificationMsg(
            'This contact is already a part of the sequence',
            null
          )
          break
        case 300:
          shareFunction.showNotificationMsg(
            `Error while adding contact to the Sequence. Please contact support at support@adapt.io`
          )
          break
        case 409:
          if (res && res.contactOwner) {
            if (res.contactOwner.sameOwner) {
              this.$store.state.salesgear.expContactType =
                'sequenceDuplicateSameUser'
            } else {
              this.$store.state.salesgear.expContactType =
                'sequenceDuplicateDiffUser'
              this.$store.state.salesgear.contactOwnerName =
                res.contactOwner && res.contactOwner.name
                  ? res.contactOwner.name
                  : res.contactOwner.email
            }
            this.$store.state.salesgear.isDupContact = true
          }
          break
        case 509:
          this.$store.state.salesgear.isContactLimit = true
          break
        default:
          shareFunction.showNotificationMsg(
            `Error while adding contact to the Sequence. Please contact support at support@adapt.io`
          )
      }
    },
    //beginging of add contact to sequence flow
    async exportContact() {
      this.hideDropDown()
      this.exportAs = 'contact'
      shareFunction.track(
        MxEvent.aeAddExpContactClicked,
        { exportType: 'Salesgear', pageType: this.pageType },
        this.$store.state
      )
      if (this.contact) {
        try {
          if (this.contact) {
            this.loading = true
            const exportUrl = constructSalesgearUrl(HttpUrl.exSingleContactToAe)
            let response = await postFromCustomUrl(exportUrl, this.contact)
            this.loading = false
            if (response.status == 200 || response.status == 409) {
              response.json().then(res => {
                // eslint-disable-next-line no-unused-vars
                const { responseCode, contact = '', contactOwner = '' } = res
                if (responseCode) {
                  this.checkContactStatus(responseCode, contactOwner)
                }
              })
            } else {
              this.showFailedToExport()
            }
          } else {
            this.errorMsg = 'Unable to perform action at this time.'
          }
        } catch (err) {
          this.showFailedToExport()
          console.error('Salesgear export contact failed', err)
        }
      }
    },
    checkContactStatus(status, contactOwner = '', isFromUpdateContact = false) {
      switch (status) {
        case 200:
          shareFunction.track(
            MxEvent.aeContactExported,
            { pageType: this.pageType },
            this.$store.state
          )
          this.showExportSuccess(isFromUpdateContact)
          break
        case 409:
          shareFunction.track(
            MxEvent.aeContactDuplicatePopup,
            { pageType: this.pageType },
            this.$store.state
          )
          this.$store.state.salesgear.isDupContact = true
          if (contactOwner === undefined || contactOwner.name === null) {
            this.$store.state.salesgear.expContactType = 'duplicateSameUser'
          } else {
            this.$store.state.salesgear.contactOwnerName =
              contactOwner && contactOwner.name
                ? contactOwner.name
                : contactOwner.email
            this.$store.state.salesgear.expContactType = 'duplicateDiffUser'
          }
          break
        case 509:
          shareFunction.track(
            MxEvent.aeContactLimitUpgrade,
            { pageType: this.pageType },
            this.$store.state
          )
          this.$store.state.salesgear.isContactLimit = true
          break
        default:
          this.showFailedToExport()
          break
      }
    },
    showExportSuccess(isFromUpdateContact = false) {
      shareFunction.track('AE - AP Contact Added', null, this.$store.state)
      const msg = isFromUpdateContact
        ? 'Successfully updated this contact to Salesgear'
        : 'Successfully added this contact to Salesgear'
      shareFunction.showNotificationMsg(msg)
    },
    showFailedToExport() {
      const msg = 'Failed to add this contact to Salesgear'
      shareFunction.showNotificationMsg(msg, null)
    },
    getPhoneNumber(phonerArray) {
      if (phonerArray && phonerArray[0] && phonerArray[0].number) {
        let phoneNumbers = []
        phonerArray.map(function(item) {
          if (item.number.indexOf('*') == -1) {
            phoneNumbers.push(item.number)
          }
        })
        return phoneNumbers
      }
    },
    redirectToSalesgearSeq() {
      localStorage.setItem('SalesgearIntroBanner', true)
      shareFunction.track(
        MxEvent.aeProceedTp,
        { pageType: this.pageType },
        this.$store.state
      )
      this.showSalesgearProceed = false
      this.showDropDown = false
      this.showAeExportDropdown = false
      windowUrlRedirect(SALESGEAR_URL)
    },
    tryNowSeqContactExport() {
      this.isTryNowClicked = true
      shareFunction.track(
        MxEvent.aeBannerTryNowBtnClick,
        { pageType: this.pageType },
        this.$store.state
      )
      if (!this.isUserHasTeam) {
        this.showAeExportDropdown = true
        shareFunction.track(
          MxEvent.aeProductPage,
          { pageType: this.pageType },
          this.$store.state
        )
        windowUrlRedirect(AE_PRODUCT_BASE_URL)
      } else {
        this.showSalesgearProceed = false
        this.showAeExportDropdown = false
      }
    },
    getBannerClass() {
      if (this.showExportBannerBtn) {
        shareFunction.track(
          MxEvent.aeExportBannerShown,
          { pageType: this.pageType },
          this.$store.state
        )
        return 'banner-dropdown'
      }
      return ''
    },
    async getCustomFields() {
      let response = await getFromCustomUrl(
        constructSalesgearUrl(HttpUrl.customFields)
      )
      let res = await response.json()
      if (res && res.customFields && Object.keys(res.customFields).length) {
        this.$store.state.salesgear.customFields = res.customFields
      }
    }
  }
}
</script>

<style lang="scss">
.salesgear-crm-component {
  @include relBlock;
  .overlay {
    @include overlay(rgba(255, 255, 255, 0.54), 1, fixed);
  }
  .salesgear-wrapper {
    display: flex;

    .new-feature {
      top: -5px;
      left: 20px;
    }
    .dropdown-wrapper {
      position: absolute;
      color: $black-text;
      width: 270px;
      top: 30px;
      left: -127px;
      font-size: 15px;
      will-change: font-size;
      background: $white;
      border-radius: 10px;
      box-shadow: 0 0 22.3px 1.7px rgba(59, 59, 59, 0.14);
      border: 1px solid $bor-eb;
      z-index: 10;
      &.banner-dropdown {
        left: unset;
        right: -5px;
        li {
          cursor: pointer;
        }
      }
      .sharp__pointer {
        padding: 5px;
        display: block;
        position: absolute;
        top: -6px;
        border-top: 1px solid $bor-eb;
        border-left: 1px solid $bor-eb;
        transform: rotate(45deg);
        background: $white;
        z-index: 11;
        left: 51%;
        border-top-left-radius: 3px;
        &.banner-dropdown {
          left: unset;
          right: 20px;
          border-top-left-radius: 3px;
        }
      }
      .ae-proceed-section {
        @include relBlock();
        padding: 12px;
        text-align: center;
        letter-spacing: 0.3px;
        p {
          color: $title-dark;
          margin: 0 0 8px;
          font-weight: 600;
          font-size: 14px;
          line-height: 1.3;
        }
        .btn-blue {
          padding: 7px 15px;
          border-radius: 3px;
          letter-spacing: 0.3px;
          background: $primary-color;
          font-weight: 500;
          font-size: 14px;
        }
      }
      .menuList {
        list-style: none;
        padding: 0;
        margin: 10px;
        max-height: 200px;
        overflow: auto;
        li {
          padding: 5px 10px;
          @include flex-center;
          .svgIcon {
            padding: 0 10px;
            background-repeat: no-repeat;
            @include wt-ht(15px, 15px);
            background-size: 15px;
          }

          .text {
            font-size: 15px;
            padding: 0 5px;
          }
          #e_sequence {
            background-image: url('./../../../assets/images/sequences.png');
          }
          #e_contacts {
            background-image: url('./../../../assets/images/contacts.png');
          }
          transition: all 300ms ease;
          &:hover {
            background: rgba(33, 118, 183, 0.1);
            border-radius: 6px;
            color: $primary-color;
            transition: all 300ms ease;
          }
        }
      }
      .d-content {
        display: content;
      }
    }
    .galleryImg {
      height: 100%;
      width: 100%;
      animation: zoominoutsinglefeatured 3s infinite ease-in-out;
    }

    @keyframes zoominoutsinglefeatured {
      0% {
        transform: scale(0.8, 0.8);
      }
      50% {
        transform: scale(1, 1);
      }
      100% {
        transform: scale(0.8, 0.8);
      }
    }
  }
}
</style>
